<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          :title="$t('foods.foodDetails')"
        >
          <b-form
            ref="foodform"
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2"
                xl="8"
                offset-xl="2"
              >
                <b-tabs>
                  <b-tab
                    active
                  >

                    <template #title>
                      <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                      />
                      <span class="d-none d-sm-inline" v-text="$t('foods.generalInfo')" />
                    </template>

                    <b-row class="mt-2">

                      <b-col
                        cols="12"
                        class="mb-2"
                      >
                        <div class="d-flex justify-content-end mb-1">
                          <b-button variant="outline-warning" size="sm" @click="showHelpModal = true">
                            <feather-icon icon="HelpCircleIcon" />
                            راهنمای مرتب سازی غذاها
                          </b-button>
                        </div>
                        <div class="border rounded p-2">
                          <b-media
                            no-body
                            vertical-align="center"
                            class="flex-column flex-md-row"
                          >
                            <b-media-aside class="align-self-end">
                              <b-img
                                ref="refPreviewEl"
                                :src="Form.Image"
                                fluid
                                height="110"
                                width="170"
                                class="rounded mr-2 mb-1 mb-md-0"
                                :blank="Form.Image == null"
                                blank-color="#82868b"
                              />
                            </b-media-aside>
                            <b-media-body>
                              <label
                                class="mb-1"
                                v-text="$t('common.image')"
                                style="font-weight: 600;"
                              />
                              <br>
                              <small class="text-muted" v-text="$t('foods.limitImageSize')" />
                              <br>
                              <div class="d-inline-block mt-1">
                                <b-form-file
                                  ref="refInputEl"
                                  accept=".jpg, .png, .gif"
                                  placeholder=""
                                  name="Image"
                                  :lang="lang"
                                  @input="inputImageRenderer"
                                />
                              </div>
                            </b-media-body>
                          </b-media>
                        </div>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          :label="$t('common.title')"
                          label-for="Title"
                        >
                          <b-form-input
                            id="Title"
                            v-model="Form.Title"
                            name="Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col v-if="lang === 'fa'" md="4">
                        <b-form-group
                          :label="$t('common.country')"
                          label-for="CountryId"
                        >
                          <z-country v-model="Form.CountryId" />
                        </b-form-group>
                      </b-col>

                      <b-col v-if="lang === 'fa'" md="4">
                        <b-form-group
                          :label="$t('common.city')"
                          label-for="StateId"
                        >
                          <z-state v-model="Form.StateId" />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          :label="$t('common.category')"
                          label-for="FoodCategoryIds"
                        >
                          <z-food-category v-model="Form.FoodCategoryIds" />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <b-form-group
                          :label="$t('foods.meal')"
                          label-for="FoodMealIds"
                        >
                          <z-food-meal v-model="Form.FoodMealIds" />
                        </b-form-group>
                      </b-col>

                      <b-col v-if="lang === 'fa'" md="4">
                        <b-form-group
                          :label="$t('foods.nature')"
                          label-for="NatureType"
                        >
                          <v-select
                            v-model="Form.Nature"
                            :options="enums('NatureType')"
                            :dir="$dir"
                            label="text"
                            :clearable="true"
                            name="Nature"
                            :reduce="x => x.value"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="12">
                        <b-form-group
                          :label="$t('foods.reformers')"
                          label-for="FoodReformerIds"
                        >
                          <z-food
                            v-model="Form.FoodReformerIds"
                            :multiple="true"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        cols="12"
                        class="mt-1"
                      >
                        <b-form-group>
                          <b-form-checkbox
                            v-model="Form.Visibility"
                            name="Visibility"
                            value="true"
                            class="custom-control-success"
                          >
                            {{ $t('foods.displayUser') }}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col
                        cols="12"
                        class="mt-1"
                      >
                        <b-form-group>
                          <b-form-checkbox
                            v-model="Form.FreeCalorie"
                            name="FreeCalorie"
                            value="true"
                            class="custom-control-success"
                          >
                            {{ $t('foods.useFree') }}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group class="mt-1 mb-2">
                          <b-form-checkbox
                              v-model="Form.IsLock"
                              value="true"
                              name="IsLock"
                              class="custom-control-primary"
                          >
                            {{ $t('foods.lockForNoDietUsers') }}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          :label="$t('foods.tags')"
                          label-for="Tags"
                        >
                          <b-form-tags
                            v-model="Form.Tags"
                            name="Tags"
                            input-id="Tags"
                            placeholder=""
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          :label="$t('common.description')"
                          label-for="Description"
                        >
                          <b-form-textarea
                            id="Description"
                            v-model="Form.Description"
                            name="Description"
                            rows="8"
                            no-resize
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab :title="$t('foods.nutritionalValue')">

                    <template #title>
                      <feather-icon
                        icon="SlidersIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                      />
                      <span class="d-none d-sm-inline" v-text="$t('foods.nutritionalValue')" />
                    </template>

                    <b-row class="mt-3">
                      <b-col md="6">

                        <b-form-group
                          :label="$t('foods.calorie')"
                          label-for="Calorie"
                        >

                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('common.decimalNumber') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Calorie"
                              v-model="Form.Calorie"
                              name="Calorie"
                              class="form-control"
                              :raw="false"
                              :options="options"
                              autocomplete="off"
                            />
                          </b-input-group>
                        </b-form-group>

                      </b-col>

                      <b-col md="6" />

                      <b-col md="6">

                        <b-form-group
                          :label="$t('foods.carbohydrate')"
                          label-for="Carbohydrate"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('common.decimalNumber') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Carbohydrate"
                              v-model="Form.Carbohydrate"
                              name="Carbohydrate"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>

                      </b-col>

                      <b-col md="6">

                        <b-form-group
                          :label="$t('foods.fat')"
                          label-for="Fat"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('common.decimalNumber') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Fat"
                              v-model="Form.Fat"
                              name="Fat"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>

                      </b-col>

                      <b-col md="6">

                        <b-form-group
                          :label="$t('foods.fiber')"
                          label-for="Fiber"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('common.decimalNumber') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Fiber"
                              v-model="Form.Fiber"
                              name="Fiber"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>

                      </b-col>

                      <b-col md="6">

                        <b-form-group
                          :label="$t('foods.protein')"
                          label-for="Protein"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('common.decimalNumber') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Protein"
                              v-model="Form.Protein"
                              name="Protein"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>

                      </b-col>

                      <b-col md="6">

                        <b-form-group
                          :label="$t('foods.salt')"
                          label-for="Salt"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('common.decimalNumber') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Salt"
                              v-model="Form.Salt"
                              name="Salt"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>

                      </b-col>

                      <b-col md="6">

                        <b-form-group
                          :label="$t('foods.sugar')"
                          label-for="Sugar"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('common.decimalNumber') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Sugar"
                              v-model="Form.Sugar"
                              name="Sugar"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>

                      </b-col>

                      <b-col md="6">
                        <b-form-group
                          :label="$t('foods.glycemic')"
                          label-for="Glycemic"
                        >
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              {{ $t('foods.integer') }}
                            </b-input-group-prepend>
                            <cleave
                              id="Glycemic"
                              v-model="Form.Glycemic"
                              name="Glycemic"
                              class="form-control"
                              :raw="false"
                              :options="options"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                    </b-row>
                  </b-tab>
                  <b-tab :title="$t('foods.units')">

                    <template #title>
                      <feather-icon
                        icon="PieChartIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                      />
                      <span class="d-none d-sm-inline" v-text="$t('foods.units')" />
                    </template>

                    <b-row class="mt-3">
                      <b-col cols="12">
                        <b-row
                          v-for="(item, index) in Form.FoodUnit"
                          :id="item.Id"
                          :key="item.Id"
                          ref="FoodUnit"
                        >

                          <b-col md="2">
                            <b-form-group
                              :label="$t('foods.unit')"
                            >
                              <z-food-unit
                                v-model="item.Id"
                                :unselectable="Form.FoodUnit.map(x => x.Id)"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="2">
                            <b-form-group
                              :label="$t('foods.geram')"
                            >
                              <b-form-input
                                v-model="item.GramInUnit"
                                autocomplete="off"
                                @update="changeGramInUnit(item)"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="2">
                            <b-form-group
                              :label="$t('foods.calorie')"
                            >
                              <b-form-input
                                v-model="item.Calorie"
                                @update="changeUnitCalorie(item)"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="2">
                            <b-form-group
                              :label="$t('foods.step')"
                            >
                              <v-select
                                v-model="item.Step"
                                name="Type"
                                :dir="$dir"
                                :reduce="x => x.value"
                                label="text"
                                :clearable="false"
                                :options="stepTypes"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="2">
                            <b-form-group>
                              <b-form-checkbox
                                v-model="item.IsDefault"
                                style="margin-top: 2.6rem"
                                value="true"
                                unchecked-value="false"
                                class="custom-control-success"
                                name="IsDefault"
                                @change="selectDefault(index)"
                              >
                                {{ $t('foods.default') }}
                              </b-form-checkbox>
                            </b-form-group>
                          </b-col>

                          <b-col
                            md="2"
                            class="mb-1"
                            style="display: flex; align-items: flex-end;"
                          >
                            <div v-if="foodUnitRemoveId !== index">
                              <b-button
                                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger"
                                class="btn-icon rounded-circle"
                                @click="removeFoodUnit(index)"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                />
                              </b-button>
                            </div>
                            <div v-else>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle"
                                variant="outline-primary"
                                @click="cancelFoodUnit"
                              >
                                <feather-icon icon="XIcon" />
                              </b-button>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle ml-1"
                                variant="outline-primary"
                                @click="confirmFoodUnit"
                              >
                                <feather-icon icon="CheckIcon" />
                              </b-button>
                            </div>
                          </b-col>

                          <b-col cols="12">
                            <hr>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col>
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="gradient-info"
                          @click="addFoodUnit"
                        >
                          <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                          />
                          <span v-text="$t('common.add')" />
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab :title="$t('foods.diseases')">
                    <template #title>
                      <feather-icon
                        icon="ThermometerIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                      />
                      <span class="d-none d-sm-inline" v-text="$t('foods.diseases')" />
                    </template>
                    <b-row class="mt-3">
                      <b-col cols="12">
                        <b-row
                          v-for="(item, index) in Form.FoodSickness"
                          :id="item"
                          :key="index"
                          ref="FoodSickness"
                        >

                          <b-col md="3">
                            <b-form-group
                                :label="$t('common.disease')"
                            >
                              <z-sickness
                                v-model="item.Id"
                                :unselectable="Form.FoodSickness.map(x => x.Id)"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="7">
                            <b-form-group
                              :label="$t('common.description')"
                            >
                              <b-form-input
                                v-model="item.Description"
                                autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col
                            md="2"
                            class="mb-1"
                            style="display: flex; align-items: flex-end;"
                          >
                            <div v-if="foodSicknessRemoveId !== index">
                              <b-button
                                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger"
                                class="btn-icon rounded-circle"
                                @click="removeFoodSickness(index)"
                              >
                                <feather-icon
                                  icon="TrashIcon"
                                />
                              </b-button>
                            </div>
                            <div v-else>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle"
                                variant="outline-primary"
                                @click="cancelFoodSickness"
                              >
                                <feather-icon icon="XIcon" />
                              </b-button>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle ml-1"
                                variant="outline-primary"
                                @click="confirmFoodSickness"
                              >
                                <feather-icon icon="CheckIcon" />
                              </b-button>
                            </div>
                          </b-col>

                          <b-col cols="12">
                            <hr>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col cols="12">
                        <b-button
                          v-ripple.400="'rgba(255,255,255,0.15)'"
                          variant="gradient-info"
                          @click="addFoodSickness"
                        >
                          <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                          />
                          <span v-text="$t('common.add')" />
                        </b-button>
                      </b-col>

                    </b-row>
                  </b-tab>
                </b-tabs>

                <b-row>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      {{ $t('common.save') }}
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      {{ $t('common.back') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
      <b-modal
          v-model="showHelpModal"
          v-if="showHelpModal"
          centered
          hide-footer
          title="راهنمای مرتب سازی غذاها"
          :no-close-on-backdrop="true"
          size="lg"
      >
        <img src="https://core.zirehapp.com/image/sort-guide.png" alt="sort-guide" class="w-100">
      </b-modal>
    </b-row>
  </b-overlay>
</template>

<script>

import ZFoodCategory from '@/tools/foodcategory.vue'
import ZFoodMeal from '@/tools/foodmeal.vue'
import ZFood from '@/tools/food.vue'
import ZFoodUnit from '@/tools/foodunit.vue'
import ZCountry from '@/tools/country.vue'
import ZState from '@/tools/state.vue'
import ZSickness from '@/tools/sickness.vue'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import draggable from 'vuedraggable'
import i18n from "@/libs/i18n";

export default {
  name: 'FoodDetails',
  components: {
    ZFoodCategory,
    ZFoodMeal,
    ZFood,
    ZFoodUnit,
    ZCountry,
    ZState,
    ZSickness,
    draggable,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        Language: null,
        Tags: null,
        Calorie: null,
        Carbohydrate: null,
        Fat: null,
        Fiber: null,
        Glycemic: null,
        Protein: null,
        Salt: null,
        Sugar: null,
        FreeCalorie: false,
        Visibility: true,
        Recipes: null,
        CountryId: null,
        StateId: null,
        Nature: null,
        FoodCategoryIds: [],
        FoodMealIds: [],
        FoodUnit: [],
        FoodSickness: [],
        FoodReformerIds: [],
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
        onValueChanged: this.changeCalorie,
      },
      IsDefaultIndex: 5,
      foodUnitRemoveId: null,
      foodSicknessRemoveId: null,
      loading: false,
      showHelpModal: false,
    }
  },
  computed: {
    lang() {
      return i18n.locale
    },
    stepTypes() {
      return this.lang === 'fa' ? this.enums('StepType') : this.enums('StepTypeEn')
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addFoodSickness()
      this.addFoodUnit()
    }
  },
  methods: {
    save() {
      let url = this.$api.food.add
      if (this.$route.params.id) {
        url = this.$api.food.update
      }

      const formData = new FormData(this.$refs.foodform)

      if (typeof (this.Form.CountryId) === 'number') {
        formData.append('CountryId', this.Form.CountryId)
      }

      if (typeof (this.Form.Nature) === 'number') {
        formData.append('Nature', this.Form.Nature)
      }

      if (typeof (this.Form.StateId) === 'number') {
        formData.append('StateId', this.Form.StateId)
      }

      this.Form.FoodCategoryIds.forEach(item => {
        formData.append('FoodCategoryIds', item)
      })

      this.Form.FoodMealIds.forEach(item => {
        formData.append('FoodMealIds', item)
      })

      this.Form.FoodReformerIds.forEach(item => {
        formData.append('FoodReformerIds', item)
      })

      this.Form.FoodUnit.forEach((item, index) => {
        if (typeof (item.Id) === 'number') {
          formData.append(`FoodUnit[${index}].Id`, item.Id)
          formData.append(`FoodUnit[${index}].GramInUnit`, item.GramInUnit)
          formData.append(`FoodUnit[${index}].IsDefault`, item.IsDefault)
          formData.append(`FoodUnit[${index}].Step`, item.Step)
        }
      })

      this.Form.FoodSickness.forEach((item, index) => {
        if (typeof (item.Id) === 'number') {
          formData.append(`FoodSickness[${index}].Id`, item.Id)
          formData.append(`FoodSickness[${index}].Description`, item.Description)
        }
      })

      formData.append('Id', this.Form.Id)

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          if (!this.$route.params.id) {
            this.back()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.food.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data

          this.addFoodSickness()
        })
    },
    addFoodUnit() {
      if (this.Form.FoodUnit.length >= 3) {
        this.$bvToast.toast(this.$t('common.maxAddFoodUnit'), {
          title: this.$t('common.errorAction'),
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
        return
      }

      this.Form.FoodUnit.push({
        Id: null,
        GramInUnit: 0,
        IsDefault: false,
        Step: 0,
      })
    },
    removeFoodUnit(index) {
      this.foodUnitRemoveId = index
    },
    cancelFoodUnit() {
      this.foodUnitRemoveId = null
    },
    confirmFoodUnit() {
      this.Form.FoodUnit.splice(this.foodUnitRemoveId, 1)
      this.foodUnitRemoveId = null
    },
    addFoodSickness() {
      this.Form.FoodSickness.push({
        Id: null,
        Description: null,
      })
    },
    removeFoodSickness(index) {
      this.foodSicknessRemoveId = index
    },
    cancelFoodSickness() {
      this.foodSicknessRemoveId = null
    },
    confirmFoodSickness() {
      this.Form.FoodSickness.splice(this.foodSicknessRemoveId, 1)
      this.foodSicknessRemoveId = null
    },
    selectDefault(key) {
      this.Form.FoodUnit[key].IsDefault = true

      this.Form.FoodUnit.forEach((item, index) => {
        if (key !== index) {
          this.$set(item, 'IsDefault', false)
        }
      })
    },
    changeGramInUnit(item) {
      this.$set(item, 'Calorie', (item.GramInUnit * this.Form.Calorie).toFixed(2))
    },
    changeUnitCalorie(item) {
      this.$set(item, 'GramInUnit', (item.Calorie / this.Form.Calorie).toFixed(2))
    },
    changeCalorie() {
      this.Form.FoodUnit.forEach(item => {
        if (item.Id && item.GramInUnit) {
          this.$set(item, 'Calorie', (item.GramInUnit * this.Form.Calorie).toFixed(2))
        }
      })
    },
  },
  setup() {
    const refInputEl = ref(null)
    const refPreviewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { refPreviewEl.value.src = base64 })

    return {
      refInputEl,
      refPreviewEl,
      inputImageRenderer,
    }
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
.nav-vertical .nav.nav-tabs .nav-item .nav-link{
  justify-content: flex-end;
}
</style>
